import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { Globals } from '../../../../_globals/globals';
import { Workstep } from '../../../../_models/workstep';

import * as rootActions from '../../../../state/app.actions';
import * as fromRoot from '../../../../state/app.reducer';

@Component({
  selector: 'app-workstep-edit',
  templateUrl: './workstep-edit.component.html'
})
export class WorkstepEditComponent implements OnInit {
  title: string;
  subtitle: string;
  workstepEditForm: FormGroup;
  keyCode: number;
  staticModal: boolean;

  arrStations = [];
  arrProducts = [];
  arrPanenos = [];

  @Input() currentWorkstep: Workstep;
  @Input() filterFields: any;

  @Output() createWorkstep = new EventEmitter<any>();
  @Output() updateWorkstep = new EventEmitter<Workstep>();

  // ASIGNACIÓN DE SHORTCUTS
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event);
    this.keyCode = event.keyCode;

    // // LETRA 'c': CANCELAR CREAR PASO DE TRABAJO
    // if (this.keyCode === 67) this.buttonCancelCreateWorkstep();
    //
    // // LETRA 'g': CREAR/EDITAR PASO DE TRABAJO
    // if (this.keyCode === 71) this.buttonCreateWorkstep();
  }

  constructor(
    public router: Router,
    public globals: Globals,
    private storeRoot: Store<fromRoot.State>,
    private formBuilder: FormBuilder,
    private location: Location
  ) { }

  ngOnInit() {
    this.title = 'Módulo de Maestros';
    this.subtitle = 'Pasos de Trabajo';
    this.staticModal = false;

    this.arrStations = ['SIMPLE', 'DOBLE', 'TRIPLE', 'CUADRUPLE'];
    this.arrProducts = [0, 1];

    this.workstepEditForm = this.formBuilder.group({
      id: this.filterFields['edid'] = this.currentWorkstep.id,
      name: this.filterFields['edname'] = this.formatString(this.currentWorkstep.name),

      producttype: this.filterFields['edproducttype'] = this.currentWorkstep.producttype,
      stationsno: this.filterFields['edstationsno'] = this.currentWorkstep.stationsno,

      station0: this.filterFields['edstation0'] = this.formatString(this.currentWorkstep.station0),
      station1: this.filterFields['edstation1'] = this.formatString(this.currentWorkstep.station1),
      station2: this.filterFields['edstation2'] = this.formatString(this.currentWorkstep.station2),
      station3: this.filterFields['edstation3'] = this.formatString(this.currentWorkstep.station3),

      description: this.filterFields['eddescription'] = this.formatString(this.currentWorkstep.description),
      abbreviation: this.filterFields['edabbreviation'] = (this.currentWorkstep.abbreviation ? this.currentWorkstep.abbreviation : ''),
      flip: this.filterFields['edflip'] = this.normalizeFlipValue(this.currentWorkstep.flip),

      minutesaday: this.filterFields['workingTime'] = Number(this.currentWorkstep.minutesaday) / 60,
      minutesakilo: this.filterFields['workingSpeed'] = (this.recorteCifrasDecimales(Number(this.currentWorkstep.minutesakilo) * 60, 3)).toFixed(2),
    });
  }

  // GETTER PARA EL FÁCIL ACCESO A LOS CAMPOS DEL FORMULARIO
  get c() {
    return this.workstepEditForm.controls;
  }

  buttonCancelCreateWorkstep() {
    console.log('---> CANCEL CREATE WORKSTEP BUTTON pressed');
    this.location.back();
  }

  async buttonCreateWorkstep() {
    console.log('---> CREATE WORKSTEP BUTTON pressed');
    const fixedMinutesAKilo = this.c.minutesakilo.value / 60;

    if (!this.fieldsAreEmpty()) {
      this.clearStations();
      this.c.minutesakilo.setValue(fixedMinutesAKilo);
      this.c.minutesaday.setValue(this.c.minutesaday.value * 60);
      console.log('-->--> buttonCreateWorkstep');
      console.log(this.workstepEditForm.value);
      await this.createWorkstep.emit(this.workstepEditForm.value);
    }
  }

  buttonUpdateWorkstep() {
    console.log('---> CREATE WORKSTEP BUTTON pressed');
    const fixedMinutesAKilo = this.c.minutesakilo.value / 60;

    if (!this.fieldsAreEmpty()) {
      this.clearStations();
      this.c.minutesakilo.setValue(fixedMinutesAKilo);
      this.c.minutesaday.setValue(this.c.minutesaday.value * 60);
      console.log('-->--> buttonUpdateWorkstep: ');
      console.log(this.workstepEditForm.value);
      this.updateWorkstep.emit(this.workstepEditForm.value);
    }
  }

  clearStations() {
    if (this.c.stationsno.value === 1) {
      this.c.station0.setValue(null);
      this.c.station1.setValue(null);
      this.c.station2.setValue(null);
      this.c.station3.setValue(null);
    } else if (this.c.stationsno.value === 2) {
      this.c.station2.setValue(null);
      this.c.station3.setValue(null);
    } else if (this.c.stationsno.value === 3) {
      this.c.station3.setValue(null);
    }
  }

  fieldsAreEmpty() {
    const name = this.c.name.value;
    const producttype = this.c.producttype.value;
    const stationsno = this.c.stationsno.value;
    const station0 = this.c.station0.value;
    const station1 = this.c.station1.value;
    const station2 = this.c.station2.value;
    const station3 = this.c.station3.value;
    const minutesaday = Number(this.c.minutesaday.value);
    const minutesakilo = Number(this.c.minutesakilo.value);
    const abbreviationRaw = this.c.abbreviation.value !== null && this.c.abbreviation.value !== undefined
      ? this.c.abbreviation.value.toString().trim()
      : '';

    // console.log('---> Workstep Form Edit:');
    // console.log(this.workstepEditForm.value);

    if (name === '' || producttype === null || stationsno === null || minutesaday === null || minutesakilo === null) {
      this.showStaticModal(true, 'Los campos jornada, velocidad, nombre, tipo de producto y tipo de estación son obligatorios.', 'alert');
      this.staticModal = true;
      return true;
    } else if (abbreviationRaw !== '' && abbreviationRaw.length > 4) {
      this.showStaticModal(true, 'La abreviatura permite máximo 4 caracteres.', 'alert');
      this.staticModal = true;
      return true;
    } else if (
      (stationsno === 4 && (station0 === null || station0 === '' || station1 === null || station1 === '' || station2 === null || station2 === '' || station3 === null || station3 === '')) ||
      (stationsno === 3 && (station0 === null || station0 === '' || station1 === null || station1 === '' || station2 === null || station2 === '')) ||
      (stationsno === 2 && (station0 === null || station0 === '' || station1 === null || station1 === ''))
    ) {
      this.showStaticModal(true, 'Los nombres de las estaciones son campos obligatorios.', 'alert');
      this.staticModal = true;
      return true;
    } else {
      return false;
    }
  }

  // FUNCIONES MODALES
  showStaticModal(value: boolean, text: string, skin: string) {
    this.storeRoot.dispatch(new rootActions.ChangeInfoModal({ value: value, info: text, link: '', param: null, skin: skin }));
  }

  // FUNCIONES DE FORMATO
  formatString(cadena: string) {
    if (cadena !== undefined && cadena !== null && cadena !== '') {
      return cadena.charAt(0) + cadena.slice(1).toLowerCase();
    } else {
      return cadena;
    }
  }

  recorteCifrasDecimales(num: number, decimales: number) {
    const numStr = num.toString();
    const padCeros = new Array(decimales).fill('0').join('');
    const dot = numStr.indexOf('.');
    if (dot === -1) {
      console.log('-->--> función recorteCifrasDecimales: ' + Number(numStr + '.' + padCeros));
      return Number(numStr + '.' + padCeros);
    }
    console.log('-->--> función recorteCifrasDecimales: ' + Number(numStr.substring(0, dot) + numStr.substr(dot, decimales + 1) + padCeros.substring(numStr.length - dot - 1)));
    return Number(numStr.substring(0, dot) + numStr.substr(dot, decimales + 1) + padCeros.substring(numStr.length - dot - 1));
  }

  normalizeFlipValue(valueIn: any): number {
    return (valueIn === true || valueIn === 1 || valueIn === '1') ? 1 : 0;
  }
}
